import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const Socials = () => (
  <div className="flex flex-wrap">
    <div className="socials-text-container flex justify-center pt-3 w-full sm:w-auto">
      <span className="font-cardo--20">Join us on our socials</span>
    </div>
    <div className="socials-icons-container flex justify-center px-7 py-2 w-full sm:w-auto">
      <a
        rel="noopener noreferrer nofollow"
        target="_blank"
        href="https://www.instagram.com/redsodaband/"
        className="mr-3"
      >
        <div className="rounded-full w-9 h-9 p-[0.4rem] border-solid border-black border-2">
          <StaticImage
            className="social-icon"
            src="../../static/images/icon/instagram.png"
            alt="instagram"
          />
        </div>
      </a>
      <a
        rel="noopener noreferrer nofollow"
        target="_blank"
        href="https://www.facebook.com/RedSodaBand/"
        className="mr-3"
      >
        <div className="rounded-full w-9 h-9 p-[0.4rem] border-solid border-black border-2">
          <StaticImage
            className="social-icon"
            src="../../static/images/icon/facebook.png"
            alt="facebook"
          />
        </div>
      </a>
      <a
        rel="noopener noreferrer nofollow"
        target="_blank"
        href="https://www.youtube.com/c/RedSoda"
        className="mr-3"
      >
        <div className="rounded-full w-9 h-9 p-[0.4rem] border-solid border-black border-2">
          <StaticImage
            className="social-icon"
            src="../../static/images/icon/youtube.png"
            alt="youtube"
          />
        </div>
      </a>
    </div>
  </div>
)

export default Socials
